import { LinkedItemSearchOption } from '../types/responses/linked-items.responses';

export interface CreatePlanPayload {
  title: string;
  description: string;
  start_date: string;
  end_date: string;
  district_id: number;
  phase_displayname: string;
  deliverable_displayname: string;
  actionitem_displayname: string;
}

export interface CreateEditPhasePayload {
  title: string;
  description: string;
  status?: string;
  linked_items?: LinkedItemSearchOption[];
}

export interface PlanYearlyProgressDTO {
  schoolYears: { schoolYear: string; deliverableCount: number }[];
  totalDeliverables: number;
}

export interface UpdatePlanSharingPayload {
  is_enabled: number;
  dark_color: string;
  light_color: string;
  background_color: string;
  header_content: string | null;
  deliverables_enabled: number;
}

export interface CopyPlanPayload {
  title: string;
  district_id?: number;
  copy_notes: number;
  copy_dates: number;
  start_date: string | null;
  end_date: string | null;
}

export interface PlanFiltersDTO {
  title?: string;
  school_year?: string;
}

export const defaultSearchFilterFreeze = (): PlanFiltersDTO => ({
  title: '',
  school_year: '',
});

export enum PlanPermissionType {
  READ = 'read',
  EDIT = 'edit',
}
